<template>
	<l-marker
		ref="marker"
		v-bind:lat-lng="fromGeoJson(point.geo)"
		v-on:click="toggleActive"
	>
		<l-icon
			ref="icon"
			v-bind:icon-size="[14, 14]"
			v-bind:popup-anchor="[0, -10]"
		>
			<div class="headline rounded-full bg-gray-300 w-4 h-4">
				<div
					class="headline rounded-full bg-red-500 w-4 h-4"
					:style="'opacity:' + point.bucket"
				></div>
				<!-- {{ point.bucket }} -->
			</div>
		</l-icon>
		<l-popup ref="popup" class="font-sans text-base p-3">
			<div class="whitespace-nowrap flex space-x-2 points-baseline mr-8">
				ID: {{ point.id }}<br />
				{{ __("Name") }}: {{ point.name }}
			</div>
		</l-popup>
	</l-marker>
</template>
>

<script>
let options = require("../../cropOptions.js");
import {
	LMap,
	LTileLayer,
	LFeatureGroup,
	LMarker,
	LPopup,
	LIcon,
} from "vue2-leaflet";

export default {
	props: {
		point: {
			type: Object,
			required: true,
		},
		activeId: {
			type: Number,
			required: false,
		},
	},
	components: {
		LIcon,
		LMarker,
		LPopup,
	},
	computed: {
		isActive() {
			return this.activeId != null && this.activeId == this.point.id;
		},
	},
	data() {
		return {};
	},
	methods: {
		fromGeoJson: function (geoJ) {
			return {
				lat: geoJ.coordinates[1],
				lng: geoJ.coordinates[0],
			};
		},
		toggleActive() {
			this.$root.$emit("new-active-marker-id", this.point.id);
		},
	},
	watch: {
		activeId: function (newActiveId) {
			console.log("new active marker", newActiveId);
			if (newActiveId != this.point.id) {
				// popup should be closed
				this.$refs.marker.mapObject.closePopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 0;
			} else {
				this.$refs.marker.mapObject.openPopup();
				this.$refs.marker.mapObject.options.zIndexOffset = 6100;
			}
		},
	},
};
</script>
